export {
    getGeneratedAllTopicsApi,
    generatePrompts,
} from '../../../promptGenerator/components/ExistingTopics/query';
export { getPromptCredits } from '../../../promptGenerator/query';
export { getCredits } from '../../../create/query';

export const getPromptGenerationApi = (id) => {
    return fetch(`/api/v1/prompt-generations/${id}/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};
